import { Empty } from "antd";
import { HeartOutlined, ShoppingCartOutlined } from "@ant-design/icons";
import { FormatVND } from "../../utils/format";
import { useDevice } from "../../hooks";

const safeImage = (raw) => {
  try {
    const list = JSON.parse(raw || "[]");
    return list?.find((x) => x?.type === "image")?.data || "";
  } catch {
    return "";
  }
};

export default function ItemProduct({ product, grid = 5 }) {
  const { isMobile } = useDevice();

  if (!product?.length) return <Empty />;

  return (
    <div
      className="cyk-product-strip"
      style={{
        "--cyk-product-columns": isMobile ? 2 : Math.min(Number(grid || 5), 6)
      }}
    >
      {product.map((item, index) => {
        const image = safeImage(item?.product_image);
        const discount = Number(item?.product_discount || 0);
        const price = Number(item?.product_price || 0);
        const finalPrice = discount ? price - price * discount / 100 : price;

        return (
          <a
            key={item?.product_id || index}
            href={`/san-pham/${item?.product_slug}`}
            className="cyk-product-card"
          >
            <div className="cyk-product-image-wrap">
              {discount > 0 && (
                <span className="cyk-discount-badge">-{discount}%</span>
              )}

              <span className="cyk-heart"><HeartOutlined /></span>

              {image ? (
                <img
                  src={image}
                  alt={item?.product_name}
                  loading="lazy"
                  className="cyk-product-image"
                />
              ) : (
                <div className="cyk-product-placeholder">Y KHOA</div>
              )}
            </div>

            <div className="cyk-product-info">
              <h3>{item?.product_name}</h3>

              <div className="cyk-price-row">
                <strong>{FormatVND(finalPrice)}</strong>
                {discount > 0 && <del>{FormatVND(price)}</del>}
              </div>

              <div className="cyk-product-bottom">
                <small>{item?.product_time || "Giao nhanh"}</small>
                <span><ShoppingCartOutlined /></span>
              </div>
            </div>
          </a>
        );
      })}
    </div>
  );
}
